@if (dialogData?.variant === 'primary') {
<div
  class="dark:bg-surface-1 bg-white z-50 flex justify-center items-center p-4 rounded-2xl shadow-xl border border-slate-200/50 dark:border-slate-700/50 overflow-hidden max-w-md mx-auto"
  (click)="$event.stopPropagation()">
  <div class="w-full overflow-hidden rounded-2xl">
    <div class="p-6 pt-8 text-center">
      <div
        class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-br from-purple-500/20 to-indigo-500/20 dark:from-purple-500/30 dark:to-indigo-500/30 border border-purple-500/30 mb-5">
        <svg class="h-8 w-8 text-purple-500 dark:text-purple-400" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M15.59 14.37a6 6 0 01-5.84 7.63v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.84 2.58a14.927 14.927 0 01-.89-7.36m0 0a14.927 14.927 0 00-.89 7.36m0 0a6 6 0 005.84-7.62v-4.8" />
        </svg>
      </div>
      <h3 class="text-xl font-semibold text-slate-800 dark:text-white">{{ dialogData?.title }}</h3>
      <div class="mt-3">
        @if (dialogData?.descriptionHtml) {
        <p class="text-sm text-slate-600 dark:text-slate-300 leading-relaxed" [innerHTML]="$safeNavigationMigration(dialogData?.descriptionHtml)">
        </p>
        } @else {
        <p class="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">{{ dialogData?.description }}</p>
        }
      </div>
      @if (dialogData?.showInput) {
      <div class="mt-4 text-left">
        <label class="block text-xs font-medium text-slate-500 dark:text-slate-300 mb-1.5 ml-1">Notes</label>
        <textarea
          class="w-full flex min-h-20 rounded-xl bg-white dark:bg-slate-900 px-3 py-2 text-sm text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 border focus:outline-none focus:ring-2 focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 border-slate-200 focus:border-[#AD46FF] focus:ring-[#AD46FF]/20 dark:border-white/5 dark:focus:border-purple-500"
          [(ngModel)]="note" [placeholder]="dialogData?.inputPlaceholder || 'Add a note...'" rows="3">
          </textarea>
      </div>
      }

      @if (dialogData?.showDropdown) {
      <div class="mt-4 text-left">
        <label class="block text-xs font-medium text-slate-500 dark:text-slate-300 mb-1.5 ml-1">{{
          dialogData?.dropdownLabel || 'Select Option' }}</label>
        <select
          class="w-full h-11 rounded-xl bg-white dark:bg-slate-900 px-3 py-2 text-sm text-slate-800 dark:text-slate-100 border focus:outline-none focus:ring-2 focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 border-slate-200 focus:border-[#AD46FF] focus:ring-[#AD46FF]/20 dark:border-white/5 dark:focus:border-purple-500"
          [ngModel]="selectedDropdownValue()" (ngModelChange)="selectedDropdownValue.set($event)">
          @for (option of dialogData?.dropdownOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>
      }
    </div>

    <div class="mx-6 border-t border-slate-200 dark:border-slate-700/50"></div>

    <div class="px-6 py-4 flex gap-3 bg-slate-50/50 dark:bg-slate-900/30"
      [class.justify-start]="dialogData?.alignButtons === 'start'"
      [class.justify-end]="dialogData?.alignButtons === 'end'"
      [class.justify-center]="!dialogData?.alignButtons || dialogData?.alignButtons === 'center'">
      <app-button type="button" variant="outline" (click)="dialogRef.close()"
        [disabled]="dialogData?.loading ?? false">{{ dialogData?.cancelLabel ?? 'Cancel' }}</app-button>
      <app-button (click)="onConfirm()" type="button" variant="primary"
        [disabled]="!!((dialogData?.loading ?? false) || (dialogData?.inputRequired && !note().trim()) || dialogData?.confirmDisabled)">{{
        dialogData?.confirmLabel ?? 'OK' }}</app-button>
    </div>
  </div>
</div>
} @else {
<div class="dark:bg-slate-800 bg-white z-50 flex justify-center items-center p-4">
  <div class="w-full max-w-sm overflow-hidden" (click)="$event.stopPropagation()">
    <div class="p-6 pt-8 text-center">
      <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full dark:bg-red-900 bg-red-200 mb-5">
        <svg class="h-8 w-8 text-red-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>
      </div>

      <h3 class="text-xl font-semibold dark:text-white text-slate-800">
        {{ dialogData?.title }}
      </h3>
      <div class="mt-2">
        @if (dialogData?.descriptionHtml) {
        <p class="text-sm dark:text-white text-slate-800" [innerHTML]="$safeNavigationMigration(dialogData?.descriptionHtml)"></p>
        } @else {
        <p class="text-sm dark:text-white text-slate-800">
          {{ dialogData?.description }}
        </p>
        }
      </div>
      @if (dialogData?.showInput) {
      <div class="mt-4 text-left">
        <label class="block text-xs font-medium text-slate-500 dark:text-slate-300 mb-1.5 ml-1">Notes</label>
        <textarea
          class="w-full flex min-h-20 rounded-xl bg-white dark:bg-slate-900 px-3 py-2 text-sm text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 border focus:outline-none focus:ring-2 focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 border-slate-200 focus:border-red-500 focus:ring-red-500/20 dark:border-slate-700 dark:focus:border-red-500"
          [(ngModel)]="note" [placeholder]="dialogData?.inputPlaceholder || 'Add a note...'" rows="3">
          </textarea>
      </div>
      }

      @if (dialogData?.showDropdown) {
      <div class="mt-4 text-left">
        <label class="block text-xs font-medium text-slate-500 dark:text-slate-300 mb-1.5 ml-1">{{
          dialogData?.dropdownLabel || 'Select Option' }}</label>
        <select
          class="w-full h-11 rounded-xl bg-white dark:bg-slate-900 px-3 py-2 text-sm text-slate-800 dark:text-slate-100 border focus:outline-none focus:ring-2 focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 border-slate-200 focus:border-red-500 focus:ring-red-500/20 dark:border-slate-700 dark:focus:border-red-500"
          [ngModel]="selectedDropdownValue()" (ngModelChange)="selectedDropdownValue.set($event)">
          @for (option of dialogData?.dropdownOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>
      }
    </div>

    <div class="mx-6 border-t border-slate-200 dark:border-slate-700/50"></div>

    <div class="px-6 py-4 flex gap-2" [class.justify-start]="dialogData?.alignButtons === 'start'"
      [class.justify-end]="dialogData?.alignButtons === 'end'"
      [class.justify-center]="!dialogData?.alignButtons || dialogData?.alignButtons === 'center'">
      <app-button type="button" variant="outline" (click)="dialogRef.close()" [disabled]="dialogData?.loading ?? false">
        {{ dialogData?.cancelLabel ?? 'No' }}
      </app-button>
      <app-button (click)="onConfirm()" type="button" variant="primary"
        [disabled]="!!((dialogData?.loading ?? false) || (dialogData?.inputRequired && !note().trim()) || dialogData?.confirmDisabled)">
        {{ dialogData?.confirmLabel ?? 'Yes' }}
      </app-button>
    </div>
  </div>
</div>
}